import { useSyncExternalStore } from 'react';

// `prefers-reduced-motion` for the few things CSS cannot switch off by itself (DESIGN_SYSTEM §7: all durations
// → 0, shimmer static). `base.css` already zeroes every CSS animation and transition under the media query;
// this hook is for JS-timed motion such as the toast's countdown bar.

const QUERY = '(prefers-reduced-motion: reduce)';

function mediaQuery(): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY)
    : null;
}

function subscribe(listener: () => void) {
  const mq = mediaQuery();
  if (!mq) return () => {};
  mq.addEventListener('change', listener);
  return () => mq.removeEventListener('change', listener);
}

function getSnapshot(): boolean {
  return mediaQuery()?.matches ?? false;
}

export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
